import {
    AfterContentInit,
    Component,
    ContentChild,
    HostBinding,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { ImmutableRedux } from "../../../redux/immutable-redux.service";
import { NS_UIState } from "../../../types";
import { CommonListActionsDirective } from "../actions.directive";
import { ACCORDIONLIST_STATE_PROP } from "../state-props";
import { commonAccordionReducerFactory } from "./reducer";

import { isEqual } from "lodash";

@Component({
    selector: "common-accordion",
    templateUrl: "./common-accordion.component.html",
})
export class CommonAccordionComponent implements OnInit, AfterContentInit, OnDestroy {
    @Input() @HostBinding("class") public classes = "u-flex-grow-1 u-display-block";
    @Input() @HostBinding("style.width") public containerWidth = "100%";
    @Input() public stateProp: string;
    @Input() public initialState: NS_UIState.IGenericListState = {
        listData: {
            params: {},
            results: [],
            expandedRows: {},
            initWhenReady: false,
        },
    };
    @Input() public toggleMode: "multiple" | "toggle" = "multiple";
    @Input() public titleProperty: string;
    @Input() public subtitleProperty: string;
    @Input() public subtitlePropertyPrefix: string;
    @ContentChild(TemplateRef, {static: false}) public templateRef: TemplateRef<any>;

    public accordion$: Subscription;
    public results: any[] = [];
    public expandedRows: { [key: string]: boolean } = {};
    public initialized = false;

    constructor(
        private ngRedux: ImmutableRedux<any>,
        public listActions: CommonListActionsDirective,
        @Inject(ACCORDIONLIST_STATE_PROP) public rootProp,
    ) {
        listActions.rootProp = this.rootProp;
        listActions.isExpandable = true;
    }

    public ngOnInit(): void {
        this.ngRedux.registerComponent(commonAccordionReducerFactory, this.rootProp, this.stateProp, this.initialState);
    }

    public ngAfterContentInit(): void {
        this.accordion$ = this.ngRedux.select(this.rootProp, this.stateProp).subscribe((state: any) => {
            this.initialized = true;
            if (!isEqual(this.results, state.listData.results)) {
                this.results = state.listData.results;
            }
            this.expandedRows = state.listData.expandedRows;
        });
    }

    public ngOnDestroy() {
        if (!!this.accordion$) {
            this.accordion$.unsubscribe();
        }
    }

    public headerTitle(item) {
        return item[this.titleProperty];
    }

    public headerSubtitle(item) {
        if (this.subtitlePropertyPrefix) {
            return `${this.subtitlePropertyPrefix} ${item[this.subtitleProperty]}`;
        } else {
            return item[this.subtitleProperty];
        }
    }
}
